module.exports = __webpack_public_path__ + "fonts/VetoSans-Light_2.fabe2f47.ttf";